import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Container = styled.div<{ isSelected: boolean }>`
  border-radius: ${theme.borderRadius.medium};
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.blackOpacity87}`
      : `1px solid ${theme.color.grey14}`};

  &:focus {
    border: 1px solid ${theme.color.designSystem.blackOpacity87};
  }

  padding: ${theme.spacing.medium};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const LearnosityItem = styled.span`
  background: white;
  display: block;

  .lrn {
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.small};
    color: ${theme.color.designSystem.blackOpacity87};
  }

  .lrn .lrn_btn,
  .lrn .lrn_btn:hover,
  .lrn .lrn_btn.lrn_hover,
  .lrn .lrn_btn:active,
  .lrn .lrn_btn.lrn_active,
  .lrn .lrn_btn:focus {
    background-color: ${theme.color.white};
    border: 1px solid ${theme.color.designSystem.blackOpacity38};
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.copy};
    color: ${theme.color.designSystem.purple70};
    border-radius: 4px;
    opacity: 1;
  }

  .lrn .lrn_btn:hover,
  .lrn .lrn_btn.lrn_hover {
    background-color: hsla(265, 100%, 47%, 0.04);
  }

  .lrn .lrn_btn:active,
  .lrn .lrn_btn.lrn_active {
    box-shadow: none;
    background-color: hsla(265, 65%, 46%, 0.1);
  }

  .lrn .lrn_btn[disabled],
  .lrn .lrn_btn[disabled]:hover,
  .lrn .lrn_btn[disabled]:active,
  .lrn .lrn_btn.lrn_disabled,
  .lrn .lrn_btn.lrn_disabled:hover,
  .lrn .lrn_btn.lrn_disabled:active {
    background-color: ${theme.color.white};
    border: 1px solid ${theme.color.designSystem.blackOpacity12};
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.copy};
    color: ${theme.color.designSystem.blackOpacity38};
    border-radius: 4px;
    opacity: 1;
  }

  .lrn .lrn_submit_button:before {
    content: '';
  }
`;
